import { render, staticRenderFns } from "./CandidatesPage.vue?vue&type=template&id=66d842f9&scoped=true&"
import script from "./CandidatesPage.vue?vue&type=script&lang=js&"
export * from "./CandidatesPage.vue?vue&type=script&lang=js&"
import style0 from "./CandidatesPage.vue?vue&type=style&index=0&id=66d842f9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d842f9",
  null
  
)

export default component.exports